import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  unloadRedirect: null,
  pathname: '',
  hasReferrerID: false,
  realIp: 'no ip found',
  submitMultiSelectAnswerLoading: false,
  submitMultipleChoiceAnswerLoading: false,
  submitBulkMultipleChoiceAnswersLoading: false,
  submitSingleAnswerLoading: false,
}

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    resetState: (state, action) => {
      Object.assign(state, initialState)
    },
    setUnloadRedirect: (state, action) => {
      state.unloadRedirect = action.payload
    },
    setPathname: (state, action) => {
      state.pathname = action.payload
    },
    setHasReferrerID: (state, action) => {
      state.hasReferrerID = action.payload
    },
    setRealIp: (state, action) => {
      state.realIp = action.payload
    },
    setSubmitMultiSelectAnswerLoading: (state, action) => {
      state.submitMultiSelectAnswerLoading = action.payload
    },
    setSubmitMultipleChoiceAnswerLoading: (state, action) => {
      state.submitMultipleChoiceAnswerLoading = action.payload
    },
    setSubmitBulkMultipleChoiceAnswersLoading: (state, action) => {
      state.submitBulkMultipleChoiceAnswersLoading = action.payload
    },
    setSubmitSingleAnswerLoading: (state, action) => {
      state.submitSingleAnswerLoading = action.payload
    },
  },
})

export const { 
  resetState,
  setUnloadRedirect,
  setPathname,
  setHasReferrerID,
  setRealIp,
  setSubmitMultiSelectAnswerLoading,
  setSubmitMultipleChoiceAnswerLoading,
  setSubmitBulkMultipleChoiceAnswersLoading,
  setSubmitSingleAnswerLoading,
 } = globalSlice.actions

export default globalSlice.reducer
